/**
 * Get the mouse position in the screen
 * @param {React.SyntheticEvent} event
 * @returns {Object} {x: {Number}, y: {Number}}
 */
const getScreenPointerPositionFromEvent = event => {
  if (event.type === "touchend") {
    return {
      x: event.changedTouches[0].clientX,
      y: event.changedTouches[0].clientY
    };
  } else if (getEventIsTouch(event)) {
    return {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY
    };
  }
  return {
    x: event.clientX,
    y: event.clientY
  };
};

/**
 * Get the relative mouse position in a DOM Element
 * @param {React.SyntheticEvent} event
 * @param {Element} domEle
 */
const getPointerPositionInDOMElement = (event, domEl) => {
  const screenPointerPos = getScreenPointerPositionFromEvent(event);
  return getXYPositionInDOMElement(screenPointerPos.x, screenPointerPos.y, domEl);
};

/**
 * Get the relative mouse position in a DOM Element
 * @param {React.SyntheticEvent} event
 * @param {Element} domEle
 */
const getXYPositionInDOMElement = (x, y, domEl) => {
  const rect = domEl.getBoundingClientRect();
  return rect
    ? {
      x: x - rect.left,
      y: y - rect.top
    }
    : null;
};

const getEventIsTouch = e => e.type.startsWith("touch");
const getEventIsMouse = e => e.type.startsWith("mouse");

export {
  getEventIsMouse,
  getEventIsTouch,
  getPointerPositionInDOMElement,
  getScreenPointerPositionFromEvent,
  getXYPositionInDOMElement};
